import React from 'react';
import '../css/Menu.css'
import { FaFolderOpen, FaHelicopter, FaIdCard, FaPaperclip } from 'react-icons/fa6';

export default function Menu({ setActivePage }) {
    const handleClick = (buttonType) => {
        setActivePage(buttonType);
    };

    return (
        <div className='menuContainer'>
            <div className='menuItem' onClick={() => handleClick('landing')}>
                <FaHelicopter />
                <p className='menuItemName'>Landing</p>
            </div>
            <div className='menuItem' onClick={() => handleClick('resume')}>
                <FaPaperclip />
                <p className='menuItemName'>Resume</p>
            </div>
            {/* <div className='menuItem' onClick={() => handleClick('examples')}>
                <FaFolderOpen />
                <p className='menuItemName'>Example Work</p>
            </div> */}
            <div className='menuItem' onClick={() => handleClick('bio')}>
                <FaIdCard />
                <p className='menuItemName'>Bio</p>
            </div>
        </div>
    );
}